import { useContext, useCallback } from "react";

// context
import { DropDownContext } from "./index";
import { actionTypes } from "./store";

export const useDropDown = () => {
    const { state, dispatch, nonStateProps } = useContext(DropDownContext);
    const { onClose, onOpen } = nonStateProps;

    const open = useCallback(
        (shouldFocus = false) => {
            dispatch({
                type: actionTypes.SET_IS_OPEN,
                isOpen: true,
                shouldFocus
            });
            onOpen(state);
        },
        [state]
    );

    const close = useCallback(() => {
        dispatch({
            type: actionTypes.SET_IS_OPEN,
            isOpen: false,
            shouldFocus: false
        });
        onClose(state);
    }, [state]);

    const toggleIsOpen = shouldFocus => {
        const { isOpen } = state;
        const invertedIsOpen = !isOpen;
        invertedIsOpen ? open(shouldFocus) : close();
    };

    return {
        ...state,
        ...nonStateProps,
        toggleIsOpen,
        open,
        close
    };
};
